import uaParser from 'ua-parser-js';
import { publicIpv4 } from 'public-ip';
import { v4 as uuid } from 'uuid';

import storage from '@/services/storage';
import logger from '@/services/logger';
import returnAppConfig from '@/helpers/return-app-config';

// Shared attribute source for our browser monitoring providers (New Relic and
// Datadog). Both providers report the same event payload so dashboards stay
// aligned while the two run side by side.
const monitoringAttributes = {
  async getAttributes(eventParams, store) {
    const storeData = await monitoringAttributes.getStoreData(store);
    const deviceTimestamp = new Date();

    const payload = {
      ...eventParams,
      ...storeData,
      deviceTimestamp: deviceTimestamp.toJSON()
    };

    return payload;
  },

  async getStoreData(store) {
    const deviceData = await monitoringAttributes.getDeviceData();

    const merchantId = store.state.merchant.internalId;
    const storeId = store.state.locations?.selectedLocation.storeId;
    const storeName = store.state.locations?.selectedLocation.description;
    const orderId = store.state.orders?.order.orderId;
    const accountId = store.state.session?.currentUser.accountId;

    return {
      merchantId,
      storeId,
      storeName,
      orderId,
      accountId,
      ...deviceData
    };
  },

  async getDeviceData() {
    const { os, device, browser } = uaParser(window.navigator.userAgent);
    const ipV4 = await publicIpv4();
    let deviceId = storage.local.get('deviceId');

    if (!deviceId) {
      deviceId = uuid();
    }

    return {
      deviceOS: os.name,
      deviceOSVersion: os.version,
      deviceModel: device.model || null,
      browser: browser.name,
      browserVersion: browser.version,
      localIpv4: ipV4,
      deviceId
    };
  },

  triggerDebuggerLogging(providerName, eventName, attributes) {
    const { isTestEnvironment } = returnAppConfig();

    if (isTestEnvironment) {
      const logStyles = [
        'color: #5186EC; font-weight: bold',
        'color: #5186EC; font-weight: bold',
        'color: #58A55C; font-weight: bold'
      ];

      logger.log(
        `%c${providerName}%c Event:%c ${eventName}`,
        ...logStyles,
        attributes
      );
    }
  }
};

export default monitoringAttributes;
